import BaseEnumType from "../../common/base-enum-type";

const GoalPost = Object.freeze({
    GOAL_LINE: new BaseEnumType("GL", "Goal Line"),
    END_LINE: new BaseEnumType("EL", "End Line")
});

export default GoalPost;
